import { render, staticRenderFns } from "./SimpleTableComponent.vue?vue&type=template&id=1b5d4812&"
import script from "./SimpleTableComponent.vue?vue&type=script&lang=ts&"
export * from "./SimpleTableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5d4812')) {
      api.createRecord('1b5d4812', component.options)
    } else {
      api.reload('1b5d4812', component.options)
    }
    module.hot.accept("./SimpleTableComponent.vue?vue&type=template&id=1b5d4812&", function () {
      api.rerender('1b5d4812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/SimpleTableComponent.vue"
export default component.exports